import { EnvironmentProviders } from '@angular/core';
import { provideFeatureService } from '@sb/shared/feature';
import { environment } from 'src/environments/environment';

import { useFeatureServiceContext } from './feature-service-context.provider';

/**
 * Provides a feature service initializer.
 * @returns An environment provider that initializes the feature service.
 */
export const provideFeatureServiceInitializer = (): EnvironmentProviders =>
  provideFeatureService(() => ({
    unleashUrl: environment.unleashUrl,
    unleashClientKey: environment.unleashClientKey,
    environment: environment.env,
    contextSignal: useFeatureServiceContext(),
  }));
